import { render } from "./TopBar.vue?vue&type=template&id=5ed6ed67"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=5ed6ed67&lang=scss"
script.render = render

export default script